import React from 'react';
import { Box, Skeleton } from '@mui/material';
import LicenseCard from './LicenseCard';
import LicenseEmptyState from './LicenseEmptyState';
import useLicenseSx from '../hooks/useLicenseSx';

function LoadingSkeletons() {
  const styles = useLicenseSx();

  return (
    <Box sx={styles.cardGrid}>
      {[1, 2, 3].map((key) => (
        <Skeleton key={key} variant="rounded" sx={styles.skeletonCard} />
      ))}
    </Box>
  );
}

export default function LicenseCardGrid({
  licenses,
  isLoading,
  isSearching,
  statusTab = 'active',
  onCreate,
  onEdit,
  onArchive,
}) {
  const styles = useLicenseSx();

  if (isLoading) {
    return <LoadingSkeletons />;
  }

  if (!licenses.length) {
    return (
      <LicenseEmptyState
        onCreate={onCreate}
        isSearching={isSearching}
        statusTab={statusTab}
      />
    );
  }

  return (
    <Box sx={styles.cardGrid}>
      {licenses.map((license) => (
        <LicenseCard
          key={license.id ?? license.name}
          license={license}
          onEdit={onEdit}
          onArchive={onArchive}
        />
      ))}
    </Box>
  );
}
